import { DialogCloseEvent } from '@theme/dialog';

/**
 * Standalone zoom dialog for a single metafield-driven image, independent of the
 * carousel's own zoom-dialog component. Any number of trigger buttons (one per
 * gallery slide) can point at the same dialog id, since it's always the same image.
 */
document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-zoom-image-open]');
  if (opener) {
    const dialog = document.getElementById(opener.getAttribute('data-zoom-image-open'));
    if (dialog instanceof HTMLDialogElement) dialog.showModal();
    return;
  }

  const closer = event.target.closest('[data-zoom-image-close]');
  if (closer) {
    closer.closest('dialog')?.close();
    return;
  }

  const zoomInButton = event.target.closest('[data-zoom-image-in]');
  if (zoomInButton) {
    zoomInButton.closest('dialog')?.querySelector('drag-zoom-wrapper')?.zoomIn();
    return;
  }

  const zoomOutButton = event.target.closest('[data-zoom-image-out]');
  if (zoomOutButton) {
    zoomOutButton.closest('dialog')?.querySelector('drag-zoom-wrapper')?.zoomOut();
    return;
  }

  // Clicking anywhere other than the zoomed image itself closes the dialog - either the
  // true backdrop (the dialog element, not one of its children), or the drag-zoom-wrapper's
  // own empty space (it's a flex container that centers the image via object-fit: contain,
  // so at less-than-full zoom there's visible letterboxed margin around the image that isn't
  // actually part of the <img> element).
  const isDialogBackdrop = event.target instanceof HTMLDialogElement && event.target.hasAttribute('data-zoom-image-dialog');
  const isWrapperMargin = event.target instanceof HTMLElement && event.target.tagName === 'DRAG-ZOOM-WRAPPER';

  if (isDialogBackdrop) {
    event.target.close();
  } else if (isWrapperMargin) {
    event.target.closest('[data-zoom-image-dialog]')?.close();
  }
});

// The native `close` event on <dialog> doesn't bubble, so listen during the capture phase.
document.addEventListener(
  'close',
  (event) => {
    if (event.target instanceof HTMLDialogElement && event.target.hasAttribute('data-zoom-image-dialog')) {
      window.dispatchEvent(new DialogCloseEvent());
    }
  },
  true
);
